<template>
  <div class="messages" ref="thread">
    <header>
      <div class="status-message" v-if="isNewTicket">
        {{ labels.newTicketMessage }}
      </div>
      <div class="survey-question" v-if="question">
        {{ question }}
      </div>
      <div class="feelings-wrap" v-if="isNewTicket">
        <span>{{ labels.howYouFellThisFeedback }}</span>
        <div class="feelings">
          <small
            class="tag"
            @click="feeling = 'positive'"
            :class="{ positive: feeling === 'positive' }"
            >{{ labels.positive }}</small
          >
          <small
            class="tag"
            @click="feeling = 'constructive'"
            :class="{ constructive: feeling === 'constructive' }"
            >{{ labels.constructive }}</small
          >
        </div>
      </div>
    </header>

    <div class="day-wrap" v-for="(day, idx) in thread" :key="`day${idx}`">
      <div class="label-day">
        <div>{{ day.time | moment('DD/MM/YYYY') }}</div>
      </div>

      <div
        class="message"
        :class="{ owned: item.isMyMessage }"
        v-for="(item, index) in day.thread"
        :key="`item${index}`"
      >
        <div class="message-header">
          <div class="image">
            <div
              v-if="item.isAnonymous"
              class="material-icons custom-icon-incognito"
            />
            <i v-if="!item.isAnonymous" class="material-icons user-icon">
              account_circle
            </i>
          </div>
          <div class="info">
            <span class="author" v-if="item.isAnonymous">
              {{ labels.anonymous }}
            </span>
            <span class="author" v-if="!item.isAnonymous">
              {{ `${item.author.firstname} ${item.author.lastname}` }}
            </span>
          </div>
        </div>
        <div class="text-message">
          <div
            v-for="(msg, key) in item.messages"
            :key="key + JSON.stringify(msg)"
            class="mt-1"
          >
            <div class="text">
              <span v-if="msg.closed && !msg.rating">
                {{ labels.completedFeedback }}
              </span>
              <span v-if="msg.closed && msg.rating">
                <ChatRatingTicketMessage
                  :index="`${idx}_${index}`"
                  :rating="msg.rating"
                />
              </span>
              <span v-else>
                <span v-for="(line, lineIndex) in msg.text" :key="lineIndex">
                  {{ line }}
                  <br v-if="msg.text.length - 1 !== lineIndex" />
                </span>
              </span>
              <br v-if="!(msg.closed && msg.rating)" />
            </div>
            <div class="complete-feedback" v-if="msg.closed && !msg.rating">
              {{ labels.completedFeedbackBy }} &nbsp;
              <span>
                {{ `${item.author.firstname} ${item.author.lastname}` }}
              </span>
            </div>
            <div class="rate-feedback" v-if="msg.closed && msg.rating">
              <span>
                <span v-if="item.isAnonymous">
                  {{ labels.anonymous }}
                </span>
                <span v-if="!item.isAnonymous">
                  {{ `${item.author.firstname} ${item.author.lastname}` }}
                </span>
              </span>
              &nbsp; {{ labels.rateFeedbackBy }}
            </div>
          </div>
        </div>
        <ChatRatingTicket
          v-if="$can('create', 'ticket.rating')"
          :show="
            idx === thread.length - 1 &&
              index === day.thread.length - 1 &&
              item.messages[item.messages.length - 1].closed &&
              !item.messages[item.messages.length - 1].rating &&
              isMyTicket
          "
          @rateMessage="emitRateMessage"
        />
      </div>
    </div>
  </div>
</template>

<script>
import { mapGetters } from 'vuex'
import ChatRatingTicket from './ChatRatingTicket.vue'
import ChatRatingTicketMessage from './ChatRatingTicketMessage.vue'

const props = {
  isMyTicket: {
    default: false,
    required: false,
    type: Boolean,
  },
  isNewTicket: {
    default: false,
    required: false,
    type: Boolean,
  },
  question: {
    default: '',
    required: false,
    type: String,
  },
  thread: {
    type: Array,
    default: () => [],
  },
}

export default {
  props,
  components: { ChatRatingTicket, ChatRatingTicketMessage },
  data() {
    return {
      feeling: 'positive',
    }
  },
  watch: {
    feeling(value) {
      this.$emit('feeling', value)
    },
  },
  computed: {
    ...mapGetters(['resources']),
    labels: function() {
      return Object.assign(
        {},
        this.resources.page.home.feedbacks.tickets,
        this.resources.general.buttons
      )
    },
  },
  updated() {
    setTimeout(() => this.$refs.thread.scroll(0, 999999999))
  },
  methods: {
    emitRateMessage({ rating }) {
      this.$emit('rateMessage', { rating })
    },
  },
}
</script>

<style lang="scss" scoped>
@import '~@/styles/custom/colors';
.messages {
  border-bottom: 1px solid map-get($theme-colors, 'gray07');
  border-top: 1px solid map-get($theme-colors, 'gray07');
  flex-basis: 100%;
  flex-grow: 1;
  flex-shrink: 2;
  height: 150px;
  overflow: auto;

  .day-wrap {
    text-align: center;

    .label-day {
      background: map-get($theme-colors, 'light02');
      color: map-get($theme-colors, 'gray03');
      display: inline-block;
      font-size: 11px;
      border-radius: 10px;
      padding: 0.1rem 0.6rem;
    }
  }

  .feelings-wrap {
    color: map-get($theme-colors, 'gray03');
    font-weight: bold;
    text-align: center;
    padding: 0.6rem;

    .feelings {
      // color: map-get($theme-colors, 'primary');
      .tag {
        cursor: pointer;
        user-select: none;
      }
    }
  }

  header {
    border-bottom: 1px solid map-get($theme-colors, 'gray07');

    .status-message {
      color: map-get($theme-colors, 'gray03');
      font-weight: bold;
      line-height: initial;
      text-align: center;
      padding: 0.5rem;
    }

    .survey-question {
      color: map-get($theme-colors, 'gray03');
      font-weight: bold;
      line-height: initial;
      text-align: center;
      padding: 0.5rem;
    }
  }

  .message {
    margin: 0.4rem;
    text-align: left;

    .rate-feedback,
    .complete-feedback {
      display: flex;
      flex-direction: row;
      width: 100%;
      text-align: center;
      padding-top: 20px;
      font-size: 9pt;

      span {
        font-weight: bold;
      }
    }

    .rate-feedback:before,
    .rate-feedback:after,
    .complete-feedback:before,
    .complete-feedback:after {
      content: '';
      flex: 1 1;
      border-bottom: 1px solid map-get($theme-colors, 'gray07');
      margin: 10px;
    }

    .message-header {
      align-items: center;
      display: flex;
    }

    .image {
      padding: 11px 14px 0 0;
      .custom-icon-incognito {
        margin: 4px;
        background-position-x: 7px;
        background-position-y: 5px;
        border-radius: 24px;
        font-size: 24px;
        height: 45px;
        width: 45px;
      }

      .user-icon {
        color: map-get($theme-colors, 'gray07');
        font-size: 53px;
      }
    }

    .info {
      line-height: initial;
    }

    .author {
      color: map-get($theme-colors, 'septenary');
      font-weight: 500;
    }

    .text-message {
      padding: 0 4px;

      .text {
        background: map-get($theme-colors, 'white02');
        border-radius: 0 28px 28px 0;
        color: map-get($theme-colors, 'gray03');
        display: inline-block;
        padding: 10px 16px;
        text-align: left;
        font-size: 14px;
        line-height: initial;
      }

      .time {
        color: map-get($theme-colors, 'primary');
        display: block;
        font-size: 9px;
        padding-top: 4px;
      }

      :first-child {
        .text {
          border-radius: 28px 28px 28px 0;
        }
      }

      :last-child {
        .text {
          border-radius: 0 28px 28px 28px;
        }
      }
    }

    &.owned {
      text-align: right;

      .message-header {
        flex-direction: row-reverse;
      }

      .text-message {
        .text {
          color: white;
          background: map-get($theme-colors, 'primary');
          border-radius: 28px 0 0 28px;
        }

        .time {
          color: white;
          display: block;
          text-align: right;
          font-size: 9px;
          padding-top: 4px;
        }

        :first-child {
          .text {
            border-radius: 28px 28px 0 28px;
          }
        }

        :last-child {
          .text {
            border-radius: 28px 0 28px 28px;
          }
        }
      }

      .image {
        padding-left: 14px;
        padding-right: 0;

        .custom-icon-incognito {
          padding-left: 0;
        }
      }
    }
  }
}
</style>
